import React from 'react';
import { connect } from 'react-redux';
import { DBDecimalFieldObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class ObservationCircumferenceHand extends React.Component {

    render() {
        return (
            <div>
                <div className={styles.row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Circumference - DIP' />
                    <label className={styles.label}>Hand</label>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Thumb P1</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP1THUMBR'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP1THUMBL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Thumb MCP</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRMCPTHUMBR'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRMCPTHUMBL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Thumb P2</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP2THUMBR'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP2THUMBL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Thumb IP</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRIPTHUMBR'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRIPTHUMBL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Thumb P3</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP3THUMBR'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP3THUMBL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Index P1</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP1INDEXR'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP1INDEXL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Index MCP</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRMCPINDEXR'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRMCPINDEXL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Index P2</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP2INDEXR'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP2INDEXL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Index PIP</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRPIPINDEXR'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRPIPINDEXL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Index P3</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP3INDEXR'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP3INDEXL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Index DIP</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRDIPINDEXR'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRDIPINDEXL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Middle P1</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP1MIDDLER'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP1MIDDLEL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Middle MCP</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRMCPMIDDLER'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRMCPMIDDLEL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Middle P2</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP2MIDDLER'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP2MIDDLEL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Middle PIP</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRPIPMIDDLER'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRPIPMIDDLEL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Middle P3</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP3MIDDLER'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP3MIDDLEL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Middle DIP</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRDIPMIDDLER'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRDIPMIDDLEL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Ring P1</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP1RINGR'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP1RINGL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Ring MCP</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRMCPRINGR'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRMCPRINGL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Ring P2</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP2RINGR'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP2RINGL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Ring PIP</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRPIPRINGR'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRPIPRINGL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Ring P3</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP3RINGR'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP3RINGL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Ring DIP</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRDIPRINGR'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRDIPRINGL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>


                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Small P1</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP1SMALLR'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP1SMALLL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Small MCP</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRMCPSMALLR'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRMCPSMALLL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Small P2</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP2SMALLR'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP2SMALLL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Small PIP</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRPIPSMALLR'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRPIPSMALLL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Small P3</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP3SMALLR'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRP3SMALLL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Small DIP</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRDIPSMALLR'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRDIPSMALLL'
                            className={styles.circum_input}
                            min={0}
                        />
                        <label>&nbsp;&nbsp;cm</label>
                    </span>
                </div>





            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        oono: oono,
        flagged:
            (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPINDEXR !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPINDEXR !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPINDEXL !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPINDEXL !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPMIDDLER !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPMIDDLER !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPMIDDLEL !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPMIDDLEL !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPRINGR !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPRINGR !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPRINGL !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPRINGL !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPSMALLR !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPSMALLR !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPSMALLL !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPSMALLL !== null)
                ? true : false
    };
}

const connectedObservationCircumferenceHand = connect(mapStateToProps)(ObservationCircumferenceHand);
export { connectedObservationCircumferenceHand as ObservationCircumferenceHand };


